import React from "react";
import styled from "styled-components";
import Button from "../../Button";
import { breakpoints } from "../../../utils/styles";
import { addProtocolIfMissing } from "../../../utils/urls";

const Ticket = styled.div`
    display: grid;
    margin-bottom: 2rem;
    grid-template-columns: 1fr 1fr;
`;

const PosterContainer = styled.div`
    background-position: center;
    background-size: cover;
    position: relative;

    & > img { display: none !important; }

    &:after,
    &:before {
        position: absolute;
        width: 1rem;
        background: var(--local-page-bg);
        right: -0.5rem;
        content: "";
        height: 1rem;
        border-radius: 100%;
        z-index: 1;
    }
    &:after {
        bottom: -0.5rem;
    }
    &:before {
        top: -0.5rem;
    }
`

const QrContainer = styled.div`
    background: var(--page-bg);
    color: var(--text-primary);
    padding: var(--pad-y) var(--pad-x);
    position: relative;

    &:before {
        position: absolute;
        border-left: 4px dotted var(--local-page-bg);
        left: -2px;
        content: "";
        height: 94%;
        top: 3%;
    }

    body.theme-market & {
        background: var(--text-primary);
        color: var(--page-bg);
    }

    body.theme-platinum & {
        background: var(--bg-secondary);
        color: var(--primary-b);
    }
`;

const CinemaName = styled.p`
    margin: 0;
`;

const MovieTitle = styled.p`
    font-size: ${(40/12.6).toFixed(2)}rem !important;
    line-height: 1;
    margin: 0;

    body.theme-market & {
        display: block;
        font-size: 2rem !important;
        font-weight: 900;
    }

    body.theme-platinum & {
        color: var(--primary);
        display: block;
        font-size: 2rem !important;
        font-weight: 700;
        margin-top: 0.1em;
        
        @media screen and (min-width: ${breakpoints.desktop}px) {
            color: var(--primary-b);
        }
    }
`;

const QrImg = styled.img`
    display: block;
    margin: 1rem auto 1.25rem;
    width: 90%;

    body.theme-platinum & { mix-blend-mode: multiply; }
`;

function ConfirmationTicketsHead({data, bookingPdfUrl}) {
    return <Ticket>
        <PosterContainer style={{backgroundImage:'url(' + addProtocolIfMissing(data.movie.cover) + ')'}}>
            <img className="img-fluid" src={data.movie.cover} alt=""/>
        </PosterContainer>

        <QrContainer>
            <CinemaName style={{fontWeight:400}}>{data.cinema.name}</CinemaName>
            <MovieTitle className='title-1'>{data.movie.name}</MovieTitle>
            
            <QrImg className="img-fluid" src={addProtocolIfMissing(data.qr)} alt="" />
            <Button href={bookingPdfUrl} primary block target="_blank" rel="noopener noreferrer">Descargar</Button>
        </QrContainer>
    </Ticket>;
}

export default ConfirmationTicketsHead;